import type { Pendo } from '../../../shared/lib/pendo.no-deps'
import type { Cust_ICustomer } from '../Cust/Cust.ICustomer'
import type { User_IUser } from '../User/User.IUser'

declare global {
    interface Window {
        pendo?: Pendo
    }
}

// Pull the major application version from the environment. In the unlikely
// event that we don't have something sensible, default to -1
const getReleaseVersion = () => parseInt(window.ENV?.releaseVersion, 10) || -1

export function Auth_pendoIdentify(customer: Cust_ICustomer, user: User_IUser) {
    // Identify Pendo (https://developers.pendo.io/docs/?bash#initialization-and-identification)
    window.pendo?.identify({
        visitor: {
            id: user.zapticStaff ? `staff#${user.ssoId}` : user.ssoId,
            email: user.email,
            full_name: user.name,
            role: user.jobTitle ?? '',
            app_major_version: getReleaseVersion(),
        },
        account: {
            id: customer.slug,
            name: customer.name,
        },
    })
}

// Pendo isn't designed with users sharing devices in mind, so log out by giving bad data
// Please speak to system owner for Pendo if you wish to change these values
const loggedOutOptions = {
    visitor: {
        id: 'VISITOR-UNIQUE-ID' as const,
        email: 'logged-out@zaptic.com',
        full_name: 'Logged out',
        role: '',
        app_major_version: getReleaseVersion(),
    },
    account: {
        id: 'VISITOR-UNIQUE-ID',
        name: 'Logged out',
    },
}

export function Auth_pendoLogout() {
    window.pendo?.identify(loggedOutOptions)
}

export function Auth_pendoInitialize() {
    window.pendo?.initialize(loggedOutOptions)
}
